import { Router, Route, hashHistory, IndexRoute } from 'react-router';
import AppStore from '../Services/AppStore'

const config = require(`./config.${process.env.APP_ENV}.json`);

function getUrlParameter(name) {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

const clientId = getUrlParameter('clientId');
if (clientId) {
  AppStore.store('clientId', clientId);
}

export default {
  ...config,
  backend: {
    ...config.backend,
    clientId: AppStore.get('clientId') || config.backend.clientId
  }
}


// WEBPACK FOOTER //
// ./src/App/Config/index.js